import { ControllerFieldState, FieldError } from 'react-hook-form'

const errorMessage = (error: FieldError) => {
  if (error.message) {
    // if (isTranslated(error.message)) {
    //   return t(error.message) as string
    // }
    return error.message
  }

  if (error.type === 'required') {
    // return t('error.field_required')
    return 'Kenttä on pakollinen'
  }

  // return t('error.field_invalid')
  return 'Kenttä on virheellinen'
}

const extractErrorStatus = ({ error }: ControllerFieldState) => {
  const isInvalid = !!error
  return {
    error: error ? errorMessage(error) : undefined,
    isInvalid,
  }
}

export { extractErrorStatus }
